import $ from 'jquery';
import get from 'lodash/get';
import heartProduct from "modules/heart-product";
import loadFavoriteCount from "../chrome/header/load-favorite-count";

export default function(waitForFavoriteCount){
  const favProduct = get(window, 'rcProps.trigger.plp.favProduct', '');
  const $product = $('#plp-products-contents').find(`.favorite-button[data-pcode='${favProduct}']`);
  const productInPage = $product.length;
  const productIsFavorite = $product.hasClass('favorite-button--active');
  const scrollBuffer = 30;
  if(favProduct !== '') {
    const waitForFavoriteCountPromise = waitForFavoriteCount === undefined ? loadFavoriteCount : waitForFavoriteCount;
    if (productInPage) {
      waitForFavoriteCountPromise.then(() => {
        if(!productIsFavorite) {
          $product.click();
        }
        $([document.documentElement, document.body]).scrollTop($product.offset().top - scrollBuffer);
      });
    } else {
      loadFavoriteCount.then(() => {
        heartProduct('#pageItems', '.fav-item', favProduct);
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/amp-favorite.js